import React, { useCallback, useEffect, useState } from "react"
import { deleteUserSearches, fetchUserSearches, useUser, useUserSearches } from "@lib/api/user"
import styles from "@css/modules/Listings.module.scss"
import { Button, Popover, Spin } from "antd"
import { texts } from "@utils/textMessages"
import { DeleteTwoTone } from "@ant-design/icons"
import Link from "next/link"
import cn from "classnames"
import { ArrowDown, Close } from "@css/icons/SVG"
import { filtersState } from "@utils/FiltersState"
import { useFilters } from "../ListingsContainer"
import { message } from "@components/Message/message"

export const SavedSearchesDropDown = () => {
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const { user } = useUser()
    const searches = useUserSearches()
    const id = filtersState.savedSearch
    const setFilters = useFilters()

    useEffect(() => {
        if (user) {
            setLoading(true)
            fetchUserSearches().finally(() => setLoading(false))
        }
    }, [user])
    const onSelectSearch = useCallback(
        (event) => {
            const item = event.target.closest("." + styles.searchesMenuItem)
            if (item) {
                setFilters(item.dataset.key)
            }
        },
        [setFilters]
    )

    const getSearch = useCallback(
        (createdAt) => {
            const id = (createdAt || filtersState.savedSearch)?.toString()
            return searches.find((i) => i.created_at === id)
        },
        [searches]
    )

    const handleVisibleChange = useCallback((visible) => {
        setVisible(visible)
    }, [])
    const closePopover = useCallback(() => {
        setVisible(false)
    }, [])

    const onDelete = useCallback(
        async (ev, createdAt) => {
            ev.stopPropagation()
            if (confirm("Are you sure you want to delete search?")) {
                const search = getSearch(createdAt)
                try {
                    await deleteUserSearches(search.created_at)
                    message.success(`Search "${search.name}" deleted`)
                    await fetchUserSearches()
                } catch (err) {
                    console.error(err)
                    message.error(texts.somethingWentWrong)
                }
            }
        },
        [getSearch]
    )
    const renderDropdownContent = useCallback(() => {
        const menuItems = !!searches?.length && (
            <ul onClick={onSelectSearch}>
                <li key={"0"} className={cn(styles.searchesMenuItem, !id && styles.active)} data-key="0">
                    Clear selection
                </li>
                {searches.map((search) => {
                    const className = cn({
                        [styles.searchesMenuItem]: true,
                        [styles.active]: (id || 0).toString() === search.created_at.toString()
                    })
                    return (
                        <li key={search.created_at} className={className} data-key={search.created_at}>
                            {search.name}
                            <DeleteTwoTone twoToneColor="#fff" color="#fff" className={styles.deleteSearch} onClick={(ev) => onDelete(ev, search.created_at)} />
                        </li>
                    )
                })}
            </ul>
        )
        return (
            <div className={styles.searchesMenuContainer}>
                <div className={styles.searchesMenuTitle}>
                    My alerts
                    <Close onClick={closePopover} />
                </div>
                {loading && <Spin className={styles.spin} size="default" />}
                {menuItems}
                <Link href="/user">
                    <Button className={styles.manageSearches}>Manage Alerts</Button>
                </Link>
            </div>
        )
    }, [searches, closePopover, onDelete, onSelectSearch, id, loading])

    if (!user?.emails?.[0]) {
        return null
    }

    const searchName = getSearch()?.name
    const selectedSearch = searchName || "My alerts"
    const classNames = cn({
        [styles.searchesDropdown]: true,
        [styles.active]: !!searchName
    })

    const btn = (
        <Button className={classNames}>
            {selectedSearch} <ArrowDown />
        </Button>
    )

    return (
        <>
            <Popover
                overlayClassName={styles.saveSearchPopover}
                content={renderDropdownContent}
                trigger="click"
                placement="bottomRight"
                open={visible}
                onOpenChange={handleVisibleChange}>
                {btn}
            </Popover>
        </>
    )
}
